import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import React, { useCallback, useState } from "react";
import TextFieldFormControl from "../../field/TextFieldFormControl/TextFieldFormControl";
import AutocompleteField from "../../field/AutocompleteField";
import TrueFalseSelectField from "../../field/TrueFalseSelectField";

const HrParticipantDetailsForm = React.memo(({ formValue,setFormValue, filteringData, onChange,  onChangeAutocompleteWithCallback,isNew, userList }) => {
  const { t } = useTranslation();

  const [isEvaluated, setIsEvaluated] = useState(false)

  const handleChangeRole = useCallback((name, value) => {
    let selectedRole = filteringData?.participant_roles.find(rk => rk.id === value)
    setIsEvaluated(selectedRole.hrrole_is_evaluated)
    if (!selectedRole.hrrole_is_evaluated){
      setFormValue((prev) =>({...prev, self_evaluated: false}))
    }
    if (isNew){
      setFormValue((prev) =>({...prev, ...selectedRole}))
       
    }
  }, [filteringData])

 const handleChangeUser = useCallback((name, value) => {
    let selectedUser = filteringData?.users.find(rk => rk.id === value)

     if (isNew){
      setFormValue((prev) =>({...prev, ...selectedUser}))
       
    }
  }, [filteringData])

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
    >
      <Grid item xs={12}>
        <AutocompleteField
          name="hrparticipant"
          label={t("form.hr_participant_details_form.participant")}
          value={formValue?.hrparticipant}
          options={userList}
          isObjectOption={true}
          optionLabelKey="full_name"
          onChange={onChangeAutocompleteWithCallback(
            handleChangeUser
          )}
          addNewValue={false}
          multiple={false}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <AutocompleteField
          name="hrrole"
          label={t("form.hr_participant_details_form.role")}
          value={formValue?.hrrole}
          options={filteringData?.participant_roles}
          isObjectOption={true}
          optionLabelKey="hrrole_name"
          onChange={onChangeAutocompleteWithCallback(
            handleChangeRole
          )}
          addNewValue={false}
          multiple={false}
          required
        />
      </Grid>
      {isEvaluated && (
        <Grid item xs={12}>
          <TrueFalseSelectField
            name="self_evaluated"
            label={t("form.hr_participant_details_form.self_evaluated")}
            value={formValue?.self_evaluated}
            valuesAsBool
            addEmptyOptions={false}
            onChange={onChange}
          />
        </Grid>
      )}
    </Grid>
  );
});

HrParticipantDetailsForm.propTypes = {
  formValue: PropTypes.object,
  filteringData: PropTypes.object,
  onChange: PropTypes.func,
  onChangeAutocomplete: PropTypes.func,
};

export default HrParticipantDetailsForm;
